<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="verify-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3">Resend Code</h3>
      <ResendCodeForm />
    </div>
  </b-container>
</template>

<script>
import ResendCodeForm from '../../components/Forms/ResendCodeForm'

export default {
  name: 'Verify',
  components: { ResendCodeForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/ResendCode.vue?67fd1da1